import { useAuthContainer } from "./AuthContainer.hook";
import BasicButton from "../../common/components/BasicButton";

export default function AuthContainer() {
  const {
    models: { email, password, isLoading, isSubmitDisabled },
    operations: { onChange, onSubmit },
  } = useAuthContainer();

  return (
    <div className="flex h-screen w-screen flex-col items-center justify-center gap-5 bg-gradient-to-br from-slate-700 via-slate-500 to-slate-900">
      <form
        onSubmit={onSubmit}
        className="flex w-[550px] flex-col items-center gap-3 rounded-xl bg-white p-10"
      >
        <img
          src="/carelogue_logo.png"
          alt="carelogue_logo"
          className="mb-10 w-[200px]"
        />
        <div className="h-[50px] w-full overflow-hidden rounded-lg border border-zinc-300 focus-within:border-black">
          <input
            placeholder="관리자 ID"
            value={email}
            width="100%"
            onChange={(event) => onChange("email", event.target.value)}
            className="h-full w-full p-3 focus:outline-none"
          />
        </div>
        <div className="h-[50px] w-full overflow-hidden rounded-lg border border-zinc-300 focus-within:border-black">
          <input
            placeholder="비밀번호"
            type="password"
            value={password}
            width="100%"
            onChange={(event) => onChange("password", event.target.value)}
            className="h-full w-full p-3 focus:outline-none"
          />
        </div>

        <BasicButton
          text="로그인"
          disabled={isSubmitDisabled}
          className="mt-10 w-1/2 self-center"
          type="submit"
          loading={isLoading}
        />
      </form>
    </div>
  );
}
